<template>
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a :href="ceklok" target="_blank" class="card bg-primary text-white mb-3">
                <div class="card-body">
                    <h5 class="card-title text-white">Cek Log Sarana</h5>
                    <p class="card-text">Menu untuk melakukan Cek Log setiap penggunaan Sarana (Light Vihicle ).
                        <br>
                        <br>
                    </p>
                </div>
            </a>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a :href="p2h" target="_blank" class="card bg-secondary text-white mb-3">
                <div class="card-body">
                    <h5 class="card-title text-white">P2H Sarana</h5>
                    <p class="card-text">Menu untuk melakukan Pengecekan dan Pemeriksaan Harian (P2h).
                        <br>
                        <br>
                    </p>
                </div>
            </a>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a :href="servis" target="_blank" class="card bg-warning text-white mb-3">
                <div class="card-body">
                    <h5 class="card-title text-white">Servis Sarana</h5>
                    <p class="card-text">Menu untuk data servis Sarana dan jadwal melakukan servis Sarana.
                        <br>
                        <br>
                    </p>
                </div>
            </a>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a :href="ba" target="_blank" class="card bg-danger text-white mb-3">
                <div class="card-body">
                    <h5 class="card-title text-white">Berita Acara Sarana</h5>
                    <p class="card-text">Menu untuk data Berita Acara dan memasukkan hasil membuat berita acara.
                    </p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import axios from "axios";
    export default {
        mounted() {
            if(this.idsarana!=null) this.idSarana=this.idsarana
            if(this.formid!=null) this.formId=this.formid
            console.log("idSarana : "+this.idSarana)
            this.createurl()
        },
        data() {
            return {
                landingMenus: {},
                idSarana:null,
                ceklok:'',
                p2h:'',
                servis:'',
                ba:'',
                formId:''

            };
        },
        methods: {
            createurl(){
                if(this.idSarana!=''){
                    var a= this.idSarana
                    this.ceklok='/sarana/ceklog/show?idSarana='+a+'&formid='+this.formId
                    this.p2h='/sarana/p2h/show?idSarana='+a+'&formid='+this.formId
                    this.servis='/sarana/servis/show?idSarana='+a+'&formid='+this.formId
                    this.ba='/sarana/ba/show?idSarana='+a+'&formid='+this.formId
                }else{
                    this.ceklok='/sarana/ceklog/show?formid='+this.formId
                    this.p2h='/sarana/p2h/show?formid='+this.formId
                    this.servis='/sarana/servis/show?formid='+this.formId
                    this.ba='/sarana/ba/show?formid='+this.formId
                }
            }
        },
        props:["idsarana","formid"]
    }
</script>